import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';

import EnterTickets from './Enter_old/EnterTickets';
import BannerCarousel from './BannerCarousel';
import ActiveSweepstakes from './Sweepstakes/ActiveSweepstakes';
import ExpiredSweepstakes from './Sweepstakes/ExpiredSweepstakes';

import './Sweepstakes/style.scss';

export class PromotionsMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className='promotions-container'>
                <BannerCarousel name='ctl_promo_page_carousel' />
                <EnterTickets />
                <ActiveSweepstakes title='Current Promotions' variant='theme-purple' />
                <ExpiredSweepstakes title='Past Promotions' variant='theme-purple' />
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PromotionsMobile);
